import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class FormEndpoint extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'FormEndpoint',
    refs: ['form', 'success', 'error'],
    options: {
      endpoint: String,
    },
  };

  /**
   * Submit form
   * @param {*} param0
   */
  onFormSubmit({ event }) {
    event.preventDefault();
    this.fetchEndpoint();
  }

  /**
   * Fetch middleware endpoint
   * @returns {void}
   */
  fetchEndpoint() {
    fetch(this.$options.endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: new FormData(this.$refs.form),
    })
      .then((response) => response.json())
      .then(() => {
        this.$refs.success.classList.remove('hidden');
      })
      .catch(() => {
        this.$refs.error.classList.remove('hidden');
      });
  }
}
